"use strict";
exports.__esModule = true;
exports.MerchantChannelCatalogBuilder = exports.MerchantChannelCatalogProductGenerationStrategy = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var MerchantChannelCatalogProductGenerationStrategy;
(function (MerchantChannelCatalogProductGenerationStrategy) {
    MerchantChannelCatalogProductGenerationStrategy["ONE_PRODUCT_PER_PIECE"] = "ONE_PRODUCT_PER_PIECE";
    MerchantChannelCatalogProductGenerationStrategy["MANY_PRODUCTS_PER_PIECE_BY_STONES_AND_PLATING"] = "MANY_PRODUCTS_PER_PIECE_BY_STONES_AND_PLATING";
})(MerchantChannelCatalogProductGenerationStrategy = exports.MerchantChannelCatalogProductGenerationStrategy || (exports.MerchantChannelCatalogProductGenerationStrategy = {}));
var MerchantChannelCatalogBuilder = /** @class */ (function () {
    function MerchantChannelCatalogBuilder(merchantChannelCatalog) {
        this.merchantChannelCatalog = merchantChannelCatalog;
    }
    MerchantChannelCatalogBuilder.initialiseWithCatalog = function (merchantChannelCatalog) {
        return new MerchantChannelCatalogBuilder(merchantChannelCatalog);
    };
    MerchantChannelCatalogBuilder.initialiseWithOneCollection = function (collection) {
        return new MerchantChannelCatalogBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            partyId: undefined,
            channelId: undefined,
            configuration: {},
            availableCollections: [collection],
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    MerchantChannelCatalogBuilder.prototype.build = function () {
        return this.merchantChannelCatalog;
    };
    MerchantChannelCatalogBuilder.prototype.buildUpdate = function () {
        return {
            partyId: this.merchantChannelCatalog.partyId,
            channelId: this.merchantChannelCatalog.channelId,
            configuration: this.merchantChannelCatalog.configuration,
            availableCollections: this.merchantChannelCatalog.availableCollections,
            previouslyPublishedCatalog: this.merchantChannelCatalog.previouslyPublishedCatalog
        };
    };
    MerchantChannelCatalogBuilder.prototype.getId = function () {
        return this.merchantChannelCatalog.id;
    };
    MerchantChannelCatalogBuilder.prototype.withId = function (id) {
        this.merchantChannelCatalog.id = id;
        return this;
    };
    MerchantChannelCatalogBuilder.prototype.withParty = function (partyId) {
        this.merchantChannelCatalog.partyId = partyId;
        return this;
    };
    MerchantChannelCatalogBuilder.prototype.withMerchantChannel = function (channelId) {
        this.merchantChannelCatalog.channelId = channelId;
        return this;
    };
    MerchantChannelCatalogBuilder.prototype.withCollections = function (availableCollections) {
        this.merchantChannelCatalog.availableCollections = availableCollections;
        return this;
    };
    MerchantChannelCatalogBuilder.prototype.withoutPreviouslyPublishedCatalog = function () {
        this.merchantChannelCatalog.previouslyPublishedCatalog = undefined;
        return this;
    };
    MerchantChannelCatalogBuilder.prototype.withPrimaryCollectionReferences = function (shopCollectionName, shopCollectionId) {
        if (this.merchantChannelCatalog.availableCollections.length !== 1)
            throw new core_common_domain_1.Exception("Cannot have more or less than one collections in merchant channel catalog " + this.merchantChannelCatalog.id + ". Currently " + this.merchantChannelCatalog.availableCollections.length + " collections");
        this.merchantChannelCatalog.availableCollections[0].name = shopCollectionName;
        this.merchantChannelCatalog.availableCollections[0].channelShopReferenceCollection = shopCollectionId;
        return this;
    };
    MerchantChannelCatalogBuilder.prototype.clearPrimaryCollectionProducts = function () {
        /* When there are no collections in the catalog => clearing it has no effect */
        if (this.merchantChannelCatalog.availableCollections.length === 0)
            return this;
        if (this.merchantChannelCatalog.availableCollections.length !== 1)
            throw new core_common_domain_1.Exception("Cannot have more or less than one collections in merchant channel catalog " + this.merchantChannelCatalog.id + ". Currently " + this.merchantChannelCatalog.availableCollections.length + " collections");
        this.merchantChannelCatalog.availableCollections[0].products = [];
        return this;
    };
    return MerchantChannelCatalogBuilder;
}());
exports.MerchantChannelCatalogBuilder = MerchantChannelCatalogBuilder;
